import { useContext } from 'react'

import { AccountFilterContext } from 'layouts/AccountLayout/AccountFilterValuesWrapper/AccountFilterValuesWrapper'

export const useAccountFilters = () => useContext(AccountFilterContext)
